import { chartConfig } from "../chart.commonConfig";
import { PDF_CONSTANT } from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";
import { CATEGORY_LIMIT } from "../chartHelper";

export const SECOND_PIE_CHART_HELPER = data => {
  const PieChartConfig = {
    chart: {
      ...chartConfig.chart,
      type: "pie",
      height: 450,
      spacingBottom: 50,
      spacingRight: 0,
      spacingLeft: 0,
      className: "chart-background",
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.SECOND_PAGE.SECOND._SUCCESS
          });
        }
      }
    },
    title: {
      ...chartConfig.title,
      align: "center",
      text: ""
    },
    subtitle: {
      ...chartConfig.subtitle,
      y: 25,
      text: "",
      align: "center",
      verticalAlign: "bottom"
    },
    plotOptions: {
      series: {
        animation: false
      },
      pie: {
        allowPointSelect: true,
        dataLabels: {
          enabled: true,
          alignTo: "plotEdges"
        },
        showInLegend: true,
        point: {
          events: {
            legendItemClick: function() {
              this.slice(null);
              return false;
            }
          }
        }
      }
    },
    series: [
      {
        name: "Issues",
        // colorByPoint: true,
        data: [],
        startAngle: 90,
        dataLabels: {
          enabled: true,
          alignTo: "connectors",
          format: `<span style="color:{point.color}">{point.y}</span>`
        }
      }
    ],
    legend: {
      padding: 0,
      enabled: true,
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      floating: false,
      alignColumns: false
    },
    tooltip: {
      formatter: function() {
        return `
                <b>${this.key}</b><br />
                <b>Projects: ${this.y}</b>
              `;
      }
    }
  };

  try {
    // set data
    const { projectSectorDTOS: list = [], totalProjects = 0 } = data;
    let otherCounts = 0;
    list.forEach(({ sector, projectCount }, index) => {
      if (index >= CATEGORY_LIMIT) {
        otherCounts = otherCounts + projectCount;
        PieChartConfig.series[0]["data"][CATEGORY_LIMIT] =
          PieChartConfig.series[0]["data"][CATEGORY_LIMIT] || {};
        PieChartConfig.series[0]["data"][CATEGORY_LIMIT]["name"] = "Others";
        PieChartConfig.series[0]["data"][CATEGORY_LIMIT]["y"] = otherCounts;
      } else {
        PieChartConfig.series[0]["data"].push({
          name: sector,
          y: projectCount
        });
      }
    });
    PieChartConfig.title.text = `SECTOR DISTRIBUTION : ${totalProjects} PROJECTS`;
    PieChartConfig.subtitle.text = `Sector distribution for under construction/under implementation projects`;
    return PieChartConfig;
  } catch (error) {
    console.error(error);
  }
};
